import { OrderCategory } from "../../api/endpoints/Order";
import { TApiSet } from "../../api/endpoints/Set";
import { TApiSubset, TBcType } from "../../api/endpoints/Subset";
import { TOrderProductData } from "../../api/endpoints/OrderProduct";
import SubsetTypes from "../SubsetTypes";

const deriveBcType = (product: TOrderProductData<OrderCategory.REALTIME>, sets: Array<TApiSet>): TBcType => {
  let foundSubset: TApiSubset | undefined;

  sets.forEach(set => {
    set.subsets.forEach(subset => {
      const subsetId = subset.id;
      const productSubsetId = product.subset_id;

      if (subsetId === productSubsetId) {
        foundSubset = subset;
      }
    })
  });

  if (!foundSubset) {
    return null;
  }

  return foundSubset.bc_type;
}

const deriveDataSetName = (productData: TOrderProductData<OrderCategory.REALTIME>, sets: Array<TApiSet>): string => {
  let foundSet: TApiSet | undefined;
  let foundSubset: TApiSubset | undefined;

  sets.forEach(set => {
    set.subsets.forEach(subset => {
      const subsetId = subset.id;
      const productSubsetId = productData.subset_id;

      if (subsetId === productSubsetId) {
        foundSet = set;
        foundSubset = subset;
      }
    })
  });

  if (!foundSet || !foundSubset) {
    return '';
  }

  return `${foundSubset.name}: ${foundSet.description} - ${foundSubset.title} (${SubsetTypes.humanize(foundSubset.type)})`;
}

export {
  deriveDataSetName,
  deriveBcType
}
